export const honertTrim = (str)=>{
    if(typeof str === 'string'){
        str = str.replace(/(^\s*)|(\s*$)/g, "");
    }
    return str
}